import { useMemo as n } from "react";
import { useMatchRoute as r, useLocation as a } from "@tanstack/react-router";
const R = (o) => {
  const s = r(), c = a(), e = new URLSearchParams(c.search);
  return n(() => {
    const t = e.get("modal");
    return s({ to: o }) ? !0 : t ? decodeURIComponent(t) === o : !1;
  }, [o, e]);
};
export {
  R as useIsActiveRoute
};
